import { cn } from 'corso-admin-ui';
import { match } from 'ts-pattern';
import FallbackImage from '~/components/FallbackImage';
import { MediaFallback } from './MediaFallback';
import { useMediaContentType } from './useMediaContentType';

export function MediaThumbnail({
  src,
  alt,
  tone = 'light',
  className,
}: {
  src: string;
  alt: string;
  tone?: 'light' | 'dark';
  className?: string;
}) {
  const { data, isPending, isError } = useMediaContentType(src);

  if (isPending) {
    return (
      <MediaFallback
        type="loading"
        alt={alt}
        variant="chip"
        tone={tone}
        className={className}
      />
    );
  }
  if (isError) {
    return (
      <MediaFallback
        type="error"
        alt={alt}
        variant="chip"
        tone={tone}
        className={className}
      />
    );
  }

  return match(data.type)
    .with('image', () => (
      <div
        className={cn('flex size-16 items-center justify-center', className)}
      >
        <FallbackImage
          loading="lazy"
          src={src}
          alt={alt}
          className="size-full rounded-md object-cover object-center"
        />
      </div>
    ))
    .with('video', 'pdf', null, (type) => (
      <MediaFallback
        type={type}
        alt={alt}
        variant="chip"
        tone={tone}
        className={className}
      />
    ))
    .exhaustive();
}
